import { StyleSheet } from 'react-native';
import { FOCUS_COLOR } from 'src/theme-v2/focus';

export const styles = StyleSheet.create({
  button: {
    flex: 'auto',
    borderWidth: 6,
    borderColor: 'transparent',
  },
  buttonInner: {
    width: '100%',
    height: '100%',
  },
  buttonFocus: {
    borderColor: FOCUS_COLOR,
  },
  gridContainer: {
    position: 'absolute',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: '100%',
    height: '100%',
  },
  gridItem: {
    width: '100%',
    height: '100%',
  },
});
